<template>
    <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin']))" class="p-grid">
        <div class="p-col-3">
          <div class="card card-theme" id="chart-spark1">
              <apexchart type="area" height="160" :options="chartOptionsSpark1" :series="seriesSpark1"></apexchart>
          </div>
        </div>
        <div class="p-col-3">
          <div class="card card-theme" id="chart-spark2">
              <apexchart type="area" height="160" :options="chartOptionsSpark2" :series="seriesSpark2"></apexchart>
          </div>
        </div>
        <div class="p-col-3">
          <div class="card card-theme" id="chart-spark3">
              <apexchart type="area" height="160" :options="chartOptionsSpark3" :series="seriesSpark3"></apexchart>
          </div>
        </div>
        <div class="p-col-3">
          <div class="card card-theme" id="chart-spark4">
              <apexchart type="area" height="160" :options="chartOptionsSpark4" :series="seriesSpark4"></apexchart>
          </div>
        </div>
    </div>
    <div v-else class="p-grid">
      <div class="p-col-6">
        <div class="card card-theme" id="chart-spark1">
            <apexchart type="area" height="160" :options="chartOptionsSpark1" :series="seriesSpark1"></apexchart>
        </div>
      </div>
      <div class="p-col-6">
        <div class="card card-theme" id="chart-spark3">
            <apexchart type="area" height="160" :options="chartOptionsSpark3" :series="seriesSpark3"></apexchart>
        </div>
      </div>
    </div>
</template>

<script>
  import UserService from '../../services/UserService';

  export default {
    name: "SparkLines",
    props: {
      charts_data: {
        default: {}
      },
      user_accesses: {
        default: null
      }
    },
    data() {
      return {
          userService: new UserService(),

          seriesSpark1: [{
            name: 'amount',
            data: this.charts_data.vat ? this.charts_data.vat.series : []
          }],
          chartOptionsSpark1: {
            chart: {
              id: 'sparkline1',
              group: 'sparklines',
              type: 'area',
              height: 160,
              sparkline: {
                enabled: true
              },
            },
            stroke: {
              curve: 'straight'
            },
            fill: {
              opacity: 0.3,
            },
            xaxis: {
              categories: this.charts_data.categories ? this.charts_data.categories : [],
            },
            yaxis: {
              min: 0,
            },
            colors: ['#DCE6EC'],
            title: {
              text: this.charts_data.vat ? this.charts_data.vat.title : "",
              offsetX: 0,
              class: "card card-theme",
              style: {
                fontSize: '24px',
              }
            },
            subtitle: {
              text: this.charts_data.vat ? this.charts_data.vat.subtitle : "",
              offsetX: 0,
              style: {
                fontSize: '14px',
              }
            },
            tooltip: {   
              y: {
                formatter: function(e) {
                  return "£" + e.toFixed(2)
                }
              }        
            }
          },

          seriesSpark2: [{
            name: 'amount',
            data: this.charts_data.management_fee ? this.charts_data.management_fee.series : [],
          }],
          chartOptionsSpark2: {
            chart: {
              id: 'sparkline2',
              group: 'sparklines',
              type: 'area',
              height: 160,
              sparkline: {
                enabled: true
              },
            },
            stroke: {
              curve: 'straight'
            },
            fill: {
              opacity: 0.3,
            },
            xaxis: {
              categories: this.charts_data.categories ? this.charts_data.categories : [],
            },
            yaxis: {
              min: 0
            },
            colors: ['#DCE6EC'],
            title: {
              text: this.charts_data.management_fee ? this.charts_data.management_fee.title : "",
              offsetX: 0,
              style: {
                fontSize: '24px',
              },
              formatter: function(e) {
                return "£" + e.toFixed(2)
              }
            },
            subtitle: {
              text: this.charts_data.management_fee ? this.charts_data.management_fee.subtitle : "",
              offsetX: 0,
              style: {
                fontSize: '14px',
              }
            },
            tooltip: {   
              y: {
                formatter: function(e) {
                  return "£" + e.toFixed(2)
                }
              }        
            }
          },

          seriesSpark3: [{
            name: 'amount',
            data: this.charts_data.charity_total ? this.charts_data.charity_total.series : [],
          }],
          chartOptionsSpark3: {
            chart: {
              id: 'sparkline3',
              group: 'sparklines',
              type: 'area',
              height: 160,
              sparkline: {
                enabled: true
              },
            },
            stroke: {
              curve: 'straight'
            },
            fill: {
              opacity: 0.3
            },
            xaxis: {
              categories: this.charts_data.categories ? this.charts_data.categories : [],
              crosshairs: {
                width: 1
              },
            },
            yaxis: {
              min: 0,
            },
            colors: ['#DCE6EC'],
            title: {
              text: this.charts_data.charity_total ? this.charts_data.charity_total.title : "",
              offsetX: 0,
              style: {
                fontSize: '24px',
                cssClass: 'apexcharts-yaxis-title'
              }
            },
            subtitle: {
              text: this.charts_data.charity_total ? this.charts_data.charity_total.subtitle : "",
              offsetX: 0,
              style: {
                fontSize: '14px',
              }
            },
            tooltip: {   
              y: {
                formatter: function(e) {
                  return "£" + e.toFixed(2)
                }
              }        
            }
          },

          seriesSpark4: [{
            name: 'amount',
            data: this.charts_data.total ? this.charts_data.total.series : [],
          }],
          chartOptionsSpark4: {
            chart: {
              id: 'sparkline4',
              group: 'sparklines',
              type: 'area',
              height: 160,
              sparkline: {
                enabled: true
              },
            },
            stroke: {
              curve: 'straight'
            },
            fill: {
              opacity: 0.3
            },
            xaxis: {
              categories: this.charts_data.categories ? this.charts_data.categories : [],
              crosshairs: {
                width: 1
              },
            },
            yaxis: {
              min: 0,
            },
            title: {
              text: this.charts_data.total ? this.charts_data.total.title : "",
              offsetX: 0,
              style: {
                fontSize: '24px',
                cssClass: 'apexcharts-yaxis-title'
              }
            },
            subtitle: {
              text: this.charts_data.total ? this.charts_data.total.subtitle : "",
              offsetX: 0,
              style: {
                fontSize: '14px',
              }
            },
            tooltip: {   
              y: {
                formatter: function(e) {
                  return "£" + e.toFixed(2)
                }
              }        
            }
          },
      }
    },
    computed: {},
    methods: {
      randomizeArray(arg) {
        var array = arg.slice();
        var currentIndex = array.length, temporaryValue, randomIndex;

        while (0 !== currentIndex) {

          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;

          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }

        return array;
      },
    },
  }
</script>

<style scoped lang="scss">
  .card {
    margin-bottom: 0px;
  }
</style>
